module.exports = __webpack_public_path__ + "static/assets/aef77ac72ca94a368077e7f73404decc.png";